var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"mt-6 mb-6 justify-space-between pl-3"},[_c('v-list-item-content',{staticClass:"pl-2"},[_c('v-img',{attrs:{"src":require('@/assets/guardr_logo_upscaled.png')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }